import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const PackingOrderReviewItems = (props: any) => {
  const products = props.orderedItems?.products || [];

  return (
    <>
      <DataTable
        value={products}
        tableStyle={{ minWidth: "30rem", width: "100%" }} 
        size="small"
        responsiveLayout="scroll"
        className="p-datatable-sm"
        stripedRows
        showGridlines
      >
 

        <Column
          field="productName"
          style={{ width: "60%" }} 
          header="Name"
        ></Column>

        <Column
          field="quantity"
          style={{ width: "40%" }} 
          header="Quantity"
        ></Column>
      </DataTable>
    </>
  );
};

export default PackingOrderReviewItems;

 